import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Orders } from 'src/app/models/Orders.model';
import { Error } from 'src/app/models/error.model';
import { OrdersService } from 'src/app/services/orders.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import { Log } from 'src/app/services/shared/log';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '@angular/common';
import { Statistics } from 'src/app/models/stats';
import { PickerService } from 'src/app/services/picker.service';
import { Chart, registerables } from 'chart.js';
//@ts-ignore
import charts from './stats.json';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);

import { parseISO, parse } from 'date-fns';
import { StatisticsService } from 'src/app/services/shared/statistics.service';
import { __assign } from 'tslib';
import {
  ClosedOrdersStatistics,
  GeneralStatistics,
  OrdersByOperator,
  OrdersCompletedByOperator,
  OrdersDividedByCarrier,
  ShippedOrdersClosed,
  StatCompletedOrdersByCarrier,
  ShipmentsClosed,
} from 'src/app/models/Statistics.models';
import { environment } from 'src/environments/environment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ExcelService } from 'src/app/services/shared/excel.service';

@Component({
  selector: 'app-statistiche',
  templateUrl: './statistiche.component.html',
  styleUrls: ['./statistiche.component.scss'],
  standalone: false,
})


export class StatisticheComponent implements OnInit, OnDestroy {

  @ViewChild('totaleOperatoriCanvas') private totaleOperatoriCanvas!: ElementRef;
  @ViewChild('totaleCorrieriCanvas') private totaleCorrieriCanvas!: ElementRef;
  @ViewChild('corriereCanvas') private corriereCanvas!: ElementRef;
  @ViewChild('operatoreCanvas') private operatoreCanvas!: ElementRef;
  @ViewChild('ordiniEvasiCanvas') private ordiniEvasiCanvas!: ElementRef;
  @ViewChild('colliSpeditiCanvas') private colliSpeditiCanvas!: ElementRef;
  @ViewChild('mediaSpedizioniCanvas') private mediaSpedizioniCanvas!: ElementRef;
  @ViewChild('mediaOrdiniCanvas') private mediaOrdiniCanvas!: ElementRef;

  // KPI sparkline canvases — small inline trend charts inside each
  // KPI tile, in Stripe/Linear dashboard style.
  @ViewChild('sparkOrdiniCanvas') private sparkOrdiniCanvas!: ElementRef;
  @ViewChild('sparkMediaOrdiniCanvas') private sparkMediaOrdiniCanvas!: ElementRef;
  @ViewChild('sparkColliCanvas') private sparkColliCanvas!: ElementRef;
  @ViewChild('sparkMediaSpedCanvas') private sparkMediaSpedCanvas!: ElementRef;
  private sparkOrdiniChart: any;
  private sparkMediaOrdiniChart: any;
  private sparkColliChart: any;
  private sparkMediaSpedChart: any;
  private cdr = inject(ChangeDetectorRef);
  private chartsReady = false;
  private viewInitialized = false;

  public ordersStock: Orders.IOrderClosed[] = [];
  public filteredOrder: Orders.IOrderClosed[];
  public customers: string[];
  public dates: string[];
  public opened = false;
  public loading: boolean = false;
  public isSearched: boolean = false;
  public pageSize = 20;
  public searchString = 'Filtra ordini per cliente';
  public searchDate: Date = new Date();

  // Skeleton loader flag (Batch 3). True until the first generalStatistics
  // payload lands. The template shows shimmer placeholders while true.
  public isInitialLoading = true;
  public toDate = 'al giorno';
  private destroyRef = inject(DestroyRef);

  selectedOrders: Orders.OrderSelectedToSign[] = [];
  totaleOperatoriChart: any;
  totaleCorrieriChart: any;
  corriere: any;
  operatore: any;
  ordiniEvasiChart: any;
  colliSpeditiChart: any;
  mediaSpedizioniChart: any;
  mediaOrdiniChart: any;
  filterTerm: string | undefined;
  clickedOrder: string;
  clientOrder: string = 'Cliente';
  customer: string = '';
  date: string = '';
  showAll: string = 'Mostra tutti';
  showAll2: string = 'Mostra tutti';
  customerIndex: number;
  startDate: Date = new Date(2021, 0, 1);
  endDate: Date = new Date();
  dateBy: any[] = [
    {
      text: 'Data ordine',
      value: 'or_order_number',
    },
  ];
  charts = charts;

  filters = {
    dateOrginizedBy: {
      text: 'Data ordine',
      value: 'or_order_number',
    },
    startingDate: this.startDate,
    endDate: this.endDate,
    minDate: new Date(),
    maxDate: new Date(),
  };

  errori: Error.Error = new Error.Error(
    /* code */ 1,
    /* type */ 'Tipo di errore',
    /* description */ "Descrizione dell'errore",
    /* value */ 42,
    /* color */ '#FF0000', 
    /* setColor */ true 
  );

  ordini: Orders.IOrder;
  chosenYear: string = new Date().getFullYear().toString();
  yearz: number = new Date().getFullYear();
  years: string[] = [];

  // ─── Month filter (Batch 6) ────────────────────────────────────────
  //
  // Empty string = "Tutto l'anno" (default). When set to a month
  // name like 'Gennaio', the KPI tiles, highlights and leaderboards
  // zoom in on that month. Monthly trend charts (the 8 in the
  // charts-grid) stay on the full-year view — the timeline is the
  // point of those charts, so collapsing them to a single point
  // would defeat their purpose.
  //
  // The list `MONTHS_FOR_FILTER` is used as the dropdown options; the
  // first entry resets to year mode. `isMonthMode` is the boolean
  // used by all the derived getters below.

  chosenMonthName: string = '';
  readonly MONTHS_FOR_FILTER: readonly string[] = [
    "Tutto l'anno",
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile',
    'Maggio', 'Giugno', 'Luglio', 'Agosto',
    'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
  ];

  get isMonthMode(): boolean {
    return !!this.chosenMonthName;
  }

  changeMonth(value: string): void {
    this.chosenMonthName = !value || value === "Tutto l'anno" ? '' : value;
  }

  /** Helper: month-index (0..11) of the currently-selected month, or -1. */
  private get selectedMonthIndex(): number {
    return this.chosenMonthName ? this.MONTH_NAMES.indexOf(this.chosenMonthName) : -1;
  }
  monthNames = [
    {
      id: 1,
      name: 'Gennaio',
    },
    {
      id: 2,
      name: 'Febbraio',
    },
    {
      id: 3,
      name: 'Marzo',
    },
    {
      id: 4,
      name: 'Aprile',
    },
    {
      id: 5,
      name: 'Maggio',
    },
    {
      id: 6,
      name: 'Giugno',
    },
    {
      id: 7,
      name: 'Luglio',
    },
    {
      id: 8,
      name: 'Agosto',
    },
    {
      id: 9,
      // BUGFIX 2026-05-25: was 'Settembreio' (typo). The API returns
      // 'Settembre', so the typo caused September data to silently
      // disappear from any chart that did month-name matching.
      name: 'Settembre',
    },
    {
      id: 10,
      name: 'Ottobre',
    },
    {
      id: 11,
      name: 'Novembre',
    },
    {
      id: 12,
      name: 'Dicembre',
    },
  ];

  public closedOrders: Orders.IOrderClosed[] = [];
  public completedOrdersByCarrier: StatCompletedOrdersByCarrier[] = [];
  environment = environment.urlServer;

  constructor(
    private orderSrv: OrdersService,
    public closeSrv: OpenModalService,
    private translate: TranslateService,
    public openModal: OpenModalService,
    public pageService: PickerService,
    public statistics: StatisticsService,
    public excelServ: ExcelService,
  ) {
    Chart.register(...registerables);
  }

  initializeYears() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 20 }, (_, i) =>
      (currentYear - i).toString()
    );
    console.log('Years are', this.years);
  }

  ngOnInit(): void {
    this.initializeYears();
    this.getStatisticOrdersClosed();
    this.getOrders();

    this.orderSrv.getCombinedOrders()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          // value not consumed here, but the call seeds server-side caches
          // and is preserved for backward-compatibility.
        },
        error: (err) => {
          Log.error('[Statistiche] getCombinedOrders failed', err);
        },
      });
  }

  ngAfterViewInit(): void {
    this.chartsReady = true;
    this.viewInitialized = true;
  }

  ngOnDestroy(): void {
    // BUGFIX 2026-05-25 (MAJOR): the previous `Chart.unregister()` call
    // wiped the GLOBAL Chart.js registry (including the
    // `ChartDataLabels` plugin registered at module load time). Since
    // the module-level registration only runs once at import, the next
    // visit to this page had no datalabels. We now destroy each chart
    // instance to release its WebGL context and DOM listeners, and
    // leave the global registry intact.
    //
    // (subscribe cleanup is handled by `takeUntilDestroyed(destroyRef)`)
    this.destroyAllCharts();
  }

  private destroyAllCharts(): void {
    const charts = [
      this.totaleOperatoriChart,
      this.totaleCorrieriChart,
      this.corriere,
      this.operatore,
      this.ordiniEvasiChart,
      this.colliSpeditiChart,
      this.mediaSpedizioniChart,
      this.mediaOrdiniChart,
      this.sparkOrdiniChart,
      this.sparkMediaOrdiniChart,
      this.sparkColliChart,
      this.sparkMediaSpedChart,
    ];
    for (const chart of charts) {
      if (chart) chart.destroy();
    }
  }

  /**
   * Generic sparkline renderer used inside KPI tiles. Tiny line chart
   * with no axes, just the trend line + a gradient fill underneath.
   *
   * Tooltip enhanced (Batch 6) — uses month names as the label so on
   * hover the user sees "Marzo: 42" instead of just "42". The labels
   * array is generated from `this.MONTH_NAMES` so it auto-aligns to
   * the first 12 data points.
   */
  private drawSparkline(
    canvasRef: ElementRef | undefined,
    existingChart: any,
    data: number[],
    color: string,
  ): any {
    if (!canvasRef?.nativeElement || !data?.length) return existingChart;
    if (existingChart) existingChart.destroy();

    // Use the first N month names (one per data point). If the data
    // series is longer than 12 (unusual), fall back to numeric labels
    // beyond December.
    const labels = data.map((_, i) =>
      i < this.MONTH_NAMES.length ? this.MONTH_NAMES[i] : `${i + 1}`
    );
    if (!this.chartsReady) return;

    return new Chart(canvasRef.nativeElement, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          data: data,
          borderColor: color,
          backgroundColor: (context) => {
            const chart = context.chart;
            const { ctx: c, chartArea } = chart;
            if (!chartArea) return color + '20';
            const gradient = c.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, color + '55');
            gradient.addColorStop(1, color + '00');
            return gradient;
          },
          fill: true,
          tension: 0.35,
          borderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 4,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            displayColors: false,
            padding: 8,
            titleFont: { size: 12, weight: 600 },
            bodyFont: { size: 13 },
            callbacks: {
              // Title = month name; body = numeric value.
              title: (items) => (items[0]?.label as string) ?? '',
              label: (item) => `${item.parsed.y}`,
            },
          },
          datalabels: { display: false },
        },
        scales: {
          x: { display: false },
          y: { display: false, beginAtZero: true },
        },
        animation: { duration: 600 },
        interaction: { mode: 'nearest', intersect: false },
      },
    });
  }

  /** Renders/refreshes all 4 sparklines from current state. */
  private refreshSparklines(): void {
    const ordiniMonthly = this.ordiniEvasioneMonthly?.stat_monthly_closed_orders
      ?.map(o => o.stat_total_monthly_orders ?? 0) ?? [];
    const mediaOrdiniMonthly = this.ordiniShipyMonthly?.stat_average_monthly_closed_orders
      ?.map(o => o.stat_total_monthly_average_closed_orders ?? 0) ?? [];
    const mediaSpedMonthly = this.ordiniShipsMonthly?.stat_monthly_closed_orders
      ?.map(o => o.stat_total_monthly_media_boxes ?? 0) ?? [];
    const colliData: number[] = (this.colliSpeditiChart?.data?.datasets?.[0]?.data as number[]) ?? [];

    this.sparkOrdiniChart = this.drawSparkline(
      this.sparkOrdiniCanvas, this.sparkOrdiniChart, ordiniMonthly, '#017efa',
    );
    this.sparkMediaOrdiniChart = this.drawSparkline(
      this.sparkMediaOrdiniCanvas, this.sparkMediaOrdiniChart, mediaOrdiniMonthly, '#7c2dd1',
    );
    this.sparkColliChart = this.drawSparkline(
      this.sparkColliCanvas, this.sparkColliChart, colliData, '#ffc30f',
    );
    this.sparkMediaSpedChart = this.drawSparkline(
      this.sparkMediaSpedCanvas, this.sparkMediaSpedChart, mediaSpedMonthly, '#36af58',
    );
  }

  totale_operatori_data = charts.ordini_operatore.data.map((user) => {
    const nome = user.nome;
    const datiTotali = user.dati ? this.calcTot(user.dati) : 0;
    return {
      nome: nome,
      datiTotali: datiTotali,
    };
  });

  calcTot(array: number[]): number {
    return array.reduce((acc, valore) => acc + valore, 0);
  }

  /**
   * Ordini totali per operatore — horizontal bar chart, sorted desc.
   *
   * BUGFIX 2026-05-25 (Batch 2): the previous polar-area chart made it
   * hard to compare operators (you can't tell at a glance who's first
   * unless you read every legend label). A sorted horizontal bar chart
   * gives an instant ranking: longest bar at the top = top operator,
   * shortest at the bottom = lowest. Numbers on the right of each bar.
   */
  totaleOperatori(labels?: string[], data?: number[]) {
    if (this.totaleOperatoriChart) {
      this.totaleOperatoriChart.destroy();
    }
    if (!labels?.length || !data?.length) return;

    // Sort by value desc, keeping label↔data correspondence.
    const pairs = labels.map((l, i) => ({ label: l, value: data[i] ?? 0 }))
      .sort((a, b) => b.value - a.value);
    const sortedLabels = pairs.map(p => p.label);
    const sortedData = pairs.map(p => p.value);

    // Use a single brand-blue ramp; the longest bar gets the darkest.
    const max = sortedData[0] || 1;
    const bgColors = sortedData.map(v => {
      const intensity = v / max; // 0..1
      const hue = 210;
      const sat = 85;
      const lightness = 70 - intensity * 35; // 70% → 35%
      return `hsl(${hue}, ${sat}%, ${lightness}%)`;
    });
    if (!this.chartsReady) return;

    this.totaleOperatoriChart = new Chart(
      this.totaleOperatoriCanvas.nativeElement,
      {
        type: 'bar',
        data: {
          labels: sortedLabels,
          datasets: [{
            label: 'N° ordini',
            data: sortedData,
            backgroundColor: bgColors,
            borderRadius: 6,
            borderSkipped: false,
          }],
        },
        options: {
          indexAxis: 'y', // horizontal bars
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (item) => `${item.parsed.x} ordini`,
              },
            },
            datalabels: {
              display: true,
              color: '#0d2745',
              anchor: 'end',
              align: 'end',
              font: { size: 13, weight: 'bold' },
              formatter: (value) => (value === 0 ? '' : value.toFixed(0)),
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              grid: { color: '#eef1f6' },
              ticks: { color: '#6b7a90' },
            },
            y: {
              grid: { display: false },
              ticks: { color: '#0d2745', font: { weight: 600 } },
            },
          },
          layout: { padding: { right: 32 } }, // room for the end-label
        },
      }
    );
  }

  /**
   * Colli spediti per corriere — doughnut chart with center total.
   *
   * BUGFIX 2026-05-25 (Batch 2): doughnut is the canonical chart for
   * share-of-total. Each carrier becomes a slice proportional to its
   * volume; the total appears in the donut hole; the legend on the
   * right lists carriers with their absolute number.
   */
  totaleCorrieri(labels?: string[], data?: number[], total?: number) {
    if (this.totaleCorrieriChart) {
      this.totaleCorrieriChart.destroy();
    }
    if (!labels?.length || !data?.length) return;

    // Palette: a calibrated set of distinct, accessible colours. If
    // there are more carriers than colours we cycle.
    const palette = [
      '#017efa', '#7c2dd1', '#ffc30f', '#36af58',
      '#e85c44', '#0fa490', '#d6418c', '#2b3a8a',
      '#ff9f43', '#94a3b8',
    ];
    const bgColors = labels.map((_, i) => palette[i % palette.length]);
    const computedTotal = total ?? data.reduce((a, b) => a + b, 0);

    // Custom plugin: render the total in the centre of the donut.
    const centreTextPlugin = {
      id: 'centreText',
      afterDraw: (chart: any) => {
        const { ctx, chartArea } = chart;
        if (!chartArea) return;
        const cx = (chartArea.left + chartArea.right) / 2;
        const cy = (chartArea.top + chartArea.bottom) / 2;
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        // Big total
        ctx.fillStyle = '#0d2745';
        ctx.font = 'bold 26px system-ui, -apple-system, sans-serif';
        ctx.fillText(String(computedTotal), cx, cy - 6);

        // Caption underneath
        ctx.fillStyle = '#6b7a90';
        ctx.font = '600 11px system-ui, -apple-system, sans-serif';
        ctx.fillText('TOTALE COLLI', cx, cy + 16);
        ctx.restore();
      },
    };
    if (!this.chartsReady) return;

    this.totaleCorrieriChart = new Chart(
      this.totaleCorrieriCanvas.nativeElement,
      {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            label: 'Colli',
            data: data,
            backgroundColor: bgColors,
            borderColor: '#fff',
            borderWidth: 2,
            hoverOffset: 8,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '62%', // donut hole
          plugins: {
            legend: {
              position: 'right',
              labels: {
                color: '#0d2745',
                font: { size: 12, weight: 500 },
                padding: 12,
                boxWidth: 12,
                boxHeight: 12,
                usePointStyle: true,
                pointStyle: 'circle',
                generateLabels: (chart) => {
                  const dataArr = chart.data.datasets[0].data as number[];
                  const sum = dataArr.reduce((a: number, b: number) => a + b, 0) || 1;
                  return (chart.data.labels as string[]).map((label, i) => ({
                    text: `${label} — ${dataArr[i]} (${((dataArr[i] / sum) * 100).toFixed(1)}%)`,
                    fillStyle: bgColors[i],
                    strokeStyle: bgColors[i],
                    index: i,
                  })) as any;
                },
              },
            },
            tooltip: {
              callbacks: {
                label: (item) => {
                  const v = item.parsed as number;
                  const pct = computedTotal > 0 ? ((v / computedTotal) * 100).toFixed(1) : '0';
                  return ` ${item.label}: ${v} colli (${pct}%)`;
                },
              },
            },
            datalabels: { display: false }, // labels are in the legend
          },
        },
        plugins: [centreTextPlugin],
      }
    );
  }

  /**
   * Ordini per corriere (per mese).
   *
   * BUGFIX 2026-05-25 (Batch 5): same treatment as operatoreMethod —
   * stacked bar with one bar per month, segmented by carrier.
   * Carriers sorted by annual total desc for stable ordering.
   */
  corriereMethod(carrierDesc?: string[], dataForCarrier?: any[]) {
    if (this.corriere) this.corriere.destroy();
    if (!carrierDesc?.length || !dataForCarrier?.length) return;

    // Pair carrier name ↔ monthly data array, sort by annual total desc.
    const pairs = carrierDesc.map((name, i) => ({
      name: name || '—',
      monthly: (dataForCarrier[i] as number[]) ?? [],
    }));
    pairs.sort((a, b) =>
      b.monthly.reduce((s, v) => s + (v ?? 0), 0) -
      a.monthly.reduce((s, v) => s + (v ?? 0), 0)
    );

    const datasets = pairs.map((p, idx) => ({
      label: p.name,
      data: p.monthly,
      backgroundColor: this.STACK_PALETTE[idx % this.STACK_PALETTE.length],
      borderColor: 'transparent',
      borderRadius: 4,
      borderSkipped: false,
      stack: 'orders',
    }));
    if (!this.chartsReady) return;

    this.corriere = new Chart(this.corriereCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: [...this.MONTH_NAMES],
        datasets,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: '#0d2745',
              padding: 12,
              boxWidth: 12,
              boxHeight: 12,
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 12 },
            },
          },
          tooltip: {
            mode: 'index',
            callbacks: {
              label: (item) => {
                const stackTotal = item.chart.data.datasets.reduce(
                  (s: number, ds: any) => s + (Number(ds.data[item.dataIndex]) || 0),
                  0
                );
                const pct = stackTotal > 0
                  ? ((Number(item.parsed.y) / stackTotal) * 100).toFixed(0)
                  : '0';
                return ` ${item.dataset.label}: ${item.parsed.y} (${pct}%)`;
              },
              footer: (items) => {
                const total = items.reduce((s, i) => s + (Number(i.parsed.y) || 0), 0);
                return `Totale mese: ${total}`;
              },
            },
          },
          datalabels: { display: false },
        },
        scales: {
          x: { stacked: true, grid: { display: false }, ticks: { color: '#6b7a90' } },
          y: { stacked: true, beginAtZero: true, grid: { color: '#eef1f6' }, ticks: { color: '#6b7a90' } },
        },
        interaction: { mode: 'index', intersect: false },
      },
    });
  }

  operatoreLabels: string[] = [];
  operatoreDatasets: any[] = [];

  /**
   * Shared palette for the stacked monthly charts (operatori + corrieri).
   * Same colour set so the user learns one mental colour map per page.
   */
  private readonly STACK_PALETTE: readonly string[] = [
    '#017efa', '#7c2dd1', '#ffc30f', '#36af58',
    '#e85c44', '#0fa490', '#d6418c', '#2b3a8a',
    '#ff9f43', '#94a3b8', '#a04dff', '#ffd166',
  ];

  /**
   * Numero di ordini per Operatore (per mese).
   *
   * BUGFIX 2026-05-25 (Batch 5): grouped bars with 5+ operators turn
   * into spaghetti. Switched to a stacked bar chart: one bar per
   * month, segmented by operator. Reads as "monthly total + who did
   * what". Tooltip shows per-segment value + % of month + monthly
   * total in the footer.
   */
  operatoreMethod(data?: OrdersCompletedByOperator[]): void {
    if (this.operatore) this.operatore.destroy();
    if (!data?.length) return;

    const operatorMap = new Map<string, number[]>();
    data.forEach((order) => {
      const operatorName = `${order.ac_first_name ?? ''} ${order.ac_last_name ?? ''}`.trim() || '—';
      if (!operatorMap.has(operatorName)) {
        operatorMap.set(operatorName, Array(12).fill(0));
      }
      const monthIndex = this.MONTH_NAMES.indexOf(order.stat_month);
      if (monthIndex !== -1) {
        operatorMap.get(operatorName)![monthIndex] = order.nr_orders ?? 0;
      }
    });

    // Sort operators by annual total desc so the legend + stack
    // ordering are stable and the biggest contributors sit at the
    // bottom of the bar (visual weight).
    const sortedEntries = Array.from(operatorMap.entries()).sort(
      (a, b) => b[1].reduce((s, v) => s + v, 0) - a[1].reduce((s, v) => s + v, 0)
    );

    const datasets = sortedEntries.map(([name, orders], idx) => ({
      label: name,
      data: orders,
      backgroundColor: this.STACK_PALETTE[idx % this.STACK_PALETTE.length],
      borderColor: 'transparent',
      borderRadius: 4,
      borderSkipped: false,
      stack: 'orders',
    }));

    this.operatoreLabels = [...this.MONTH_NAMES];
    this.operatoreDatasets = datasets;

    if (!this.chartsReady) return;

    setTimeout(() => {
    this.operatore = new Chart(this.operatoreCanvas.nativeElement, {
      type: 'bar',
      data: { labels: this.operatoreLabels, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: '#0d2745',
              padding: 12,
              boxWidth: 12,
              boxHeight: 12,
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 12 },
            },
          },
          tooltip: {
            mode: 'index',
            callbacks: {
              label: (item) => {
                const stackTotal = item.chart.data.datasets.reduce(
                  (s: number, ds: any) => s + (Number(ds.data[item.dataIndex]) || 0),
                  0
                );
                const pct = stackTotal > 0
                  ? ((Number(item.parsed.y) / stackTotal) * 100).toFixed(0)
                  : '0';
                return ` ${item.dataset.label}: ${item.parsed.y} (${pct}%)`;
              },
              footer: (items) => {
                const total = items.reduce((s, i) => s + (Number(i.parsed.y) || 0), 0);
                return `Totale mese: ${total}`;
              },
            },
          },
          datalabels: { display: false },
        },
        scales: {
          x: { stacked: true, grid: { display: false }, ticks: { color: '#6b7a90' } },
          y: { stacked: true, beginAtZero: true, grid: { color: '#eef1f6' }, ticks: { color: '#6b7a90' } },
        },
        interaction: { mode: 'index', intersect: false },
      },
    });
    }, 0);
  }

  totaleOrdiniEvasi = charts.ordini_evasi.data.reduce(
    (acc, value) => acc + value,
    0
  );

  /**
   * Previous-year monthly arrays for the 4 monthly charts. Each is
   * captured by a parallel YoY subscribe in `getStatisticOrdersClosed`
   * and rendered as a dashed grey overlay on the corresponding chart.
   * Empty array = no overlay (initial state, or upstream fetch failed).
   */
  previousYearMonthlyOrders: number[] = [];
  previousYearMonthlyMediaOrdini: number[] = [];
  previousYearMonthlyColli: number[] = [];
  previousYearMonthlyMediaSped: number[] = [];

  /**
   * Builds the optional dashed-line dataset for a chart's YoY overlay.
   * Returns an empty array if there's no previous-year data, so the
   * spread into `datasets` is a no-op.
   */
  private yoyOverlayDataset(previousYearData: number[]): any[] {
    if (!previousYearData?.length) return [];
    return [{
      type: 'line' as const,
      label: `${+this.chosenYear - 1}`,
      data: previousYearData,
      borderColor: '#94a3b8',
      backgroundColor: 'rgba(148, 163, 184, 0.1)',
      borderDash: [6, 4],
      borderWidth: 2,
      pointRadius: 3,
      pointBackgroundColor: '#94a3b8',
      tension: 0.3,
      order: 1,
    }];
  }

  ordiniEvasi(labels?: string[], data?: number[], total?: number) {
    if (this.ordiniEvasiChart) {
      this.ordiniEvasiChart.destroy();
    }
    // BUGFIX 2026-05-25 (Batch 2): added a YoY overlay — a dashed line
    // showing the previous year's monthly orders on top of the current
    // year's bars. Allows the manager to read the trend at a glance.
    const previousYearData = this.previousYearMonthlyOrders.length
      ? this.previousYearMonthlyOrders
      : undefined;
    const previousYearLabel = `${+this.chosenYear - 1}`;

    if (!this.chartsReady) return;

    setTimeout(() => {
      this.ordiniEvasiChart = new Chart(this.ordiniEvasiCanvas.nativeElement, {
        type: 'bar',
        data: {
          labels: labels?.length ? labels : charts.ordini_evasi.labels,
          datasets: [
            {
              type: 'bar',
              label: `${this.chosenYear}`,
              data: data,
              backgroundColor: charts.ordini_evasi.bkgColor,
              borderColor: charts.ordini_evasi.borderColor,
              borderWidth: charts.ordini_evasi.borderWidth,
              borderRadius: 6,
              order: 2,
            },
            ...(previousYearData
              ? [{
                  type: 'line' as const,
                  label: previousYearLabel,
                  data: previousYearData,
                  borderColor: '#94a3b8',
                  backgroundColor: 'rgba(148, 163, 184, 0.1)',
                  borderDash: [6, 4],
                  borderWidth: 2,
                  pointRadius: 3,
                  pointBackgroundColor: '#94a3b8',
                  tension: 0.3,
                  order: 1,
                }]
              : []),
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            title: {
              display: true,
              text: charts.ordini_evasi.title /*+ 
                    `${this.calculateTotalOrdersEvasi().toFixed(0)}`*/,
              font: {
                size: charts.font.sizeM,
                weight: +charts.font.weight,
                family: charts.font.family,
              },
              padding: {
                top: charts.font.top,
                bottom: charts.font.bottom,
              },
            },
            legend: {
              display: true,
              labels: {
                font: {
                  size: charts.font.sizeS,
                  family: charts.font.family,
                },
              },
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (tooltipItem) {
                  return `${tooltipItem.label}: ${tooltipItem.raw}`;
                },
              },
            },
            // BUGFIX 2026-05-25 (Batch 7): datalabels removed from the
            // monthly bar charts. With the YoY dashed line overlay
            // showing previous-year values on top of the current-year
            // bars, the two sets of bold labels overlapped and made the
            // chart unreadable. Tooltip on hover already shows the
            // exact value (desktop-only admin portal, no touch concern).
            datalabels: { display: false },
          },
        },
      });
    }, 0);
  }

  totaleColliSpediti = charts.colli_spediti.data.reduce(
    (acc: any, value: any) => acc + value,
    0
  );

  colliSpediti(labels?: string[], data?: number[], total?: number) {
    if (this.colliSpeditiChart) {
      this.colliSpeditiChart.destroy();
    }
    if (!this.chartsReady) return;

    setTimeout(() => {
      this.colliSpeditiChart = new Chart(this.colliSpeditiCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: labels?.length ? labels : charts.colli_spediti.labels,
        datasets: [
          {
            type: 'bar' as const,
            label: `${this.chosenYear}`,
            data: data,
            backgroundColor: charts.colli_spediti.bkgColor,
            borderColor: charts.colli_spediti.borderColor,
            borderWidth: charts.colli_spediti.borderWidth,
            borderRadius: 6,
            order: 2,
          },
          ...this.yoyOverlayDataset(this.previousYearMonthlyColli),
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        plugins: {
          title: {
            display: true,
            text: charts.colli_spediti.title /*+ 
                  `${this.calculateTotalColliSpediti().toFixed(0)}`*/,
            font: {
              size: charts.font.sizeM,
              weight: +charts.font.weight,
              family: charts.font.family,
            },
            padding: {
              top: charts.font.top,
              bottom: charts.font.bottom,
            },
          },
          legend: {
            display: true,
            labels: {
              font: {
                size: charts.font.sizeS,
                family: charts.font.family,
              },
            },
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem) {
                return `${tooltipItem.label}: ${tooltipItem.raw}`;
              },
            },
          },
          // BUGFIX 2026-05-25 (Batch 7): datalabels removed — see the
          // matching note in ordiniEvasi above.
          datalabels: { display: false },
        },
      },
    });
    }, 0);
  }

  mediaSpedizioni(labels?: string[], data?: number[], total?: number) {
    if (this.mediaSpedizioniChart) {
      this.mediaSpedizioniChart.destroy();
    }
    if (!this.chartsReady) return;

    setTimeout(() => {
    this.mediaSpedizioniChart = new Chart(
      this.mediaSpedizioniCanvas.nativeElement,
      {
        type: 'bar',
        data: {
          labels: labels?.length ? labels : charts.media_spedizioni.labels,
          datasets: [
            {
              type: 'bar' as const,
              label: `${this.chosenYear}`,
              data: data,
              backgroundColor: charts.media_spedizioni.bkgColor,
              borderColor: charts.media_spedizioni.borderColor,
              borderWidth: charts.media_spedizioni.borderWidth,
              borderRadius: 6,
              order: 2,
            },
            ...this.yoyOverlayDataset(this.previousYearMonthlyMediaSped),
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value: number | string) {
                  return typeof value === 'number' ? value.toFixed(2) : value;
                },
              },
            },
          },
          plugins: {
            title: {
              display: true,
              text: charts.media_spedizioni.title /*+
                `${this.calculateTotalMediaSpedizioni().toFixed(2)}`*/,
              font: {
                size: charts.font.sizeM,
                weight: +charts.font.weight,
                family: charts.font.family,
              },
              padding: {
                top: charts.font.top,
                bottom: charts.font.bottom,
              },
            },
            legend: {
              display: true,
              labels: {
                font: {
                  size: charts.font.sizeS,
                  family: charts.font.family,
                },
              },
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (tooltipItem) {
                  return `${tooltipItem.label}: ${tooltipItem.raw}`;
                },
              },
            },
            // BUGFIX 2026-05-25 (Batch 7): datalabels disabled — same
            // rationale as the other monthly bar charts (overlap with
            // YoY line + chaotic numbers). Tooltip on hover shows the
            // exact value.
            datalabels: { display: false },
          },
        },
      }
    );
    }, 0);
  }

  calcMedia(total: number[], days: number[]): number[] {
    return total.map((value, index) => {
      if (index < days.length && days[index] > 0) {
        return value / days[index];
      } else {
        return 0;
      }
    });
  }
  media_ordini = this.calcMedia(
    charts.ordini_evasi.data,
    charts.giorni_lavorativi.data
  );
  totaleMediaOrdini = this.media_ordini.reduce((acc, value) => acc + value, 0);
  mediaMediaOrdini =
    this.media_ordini.length > 0
      ? this.totaleMediaOrdini / this.media_ordini.length
      : 0;

  media_spedizioni = this.calcMedia(
    charts.colli_spediti.data,
    charts.giorni_lavorativi.data
  );
  totaleMediaSpedizioni = this.media_spedizioni.reduce(
    (acc, value) => acc + value,
    0
  );
  mediaMediaSpedizioni =
    this.media_spedizioni.length > 0
      ? this.totaleMediaSpedizioni / this.media_spedizioni.length
      : 0;

  mediaOrdini(labels?: string[], data?: number[], total?: number) {
    if (this.mediaOrdiniChart) {
      this.mediaOrdiniChart.destroy();
    }
    if (!this.chartsReady) return;

    setTimeout(() => {
    this.mediaOrdiniChart = new Chart(this.mediaOrdiniCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: labels?.length ? labels : charts.media_ordini.labels,
        datasets: [
          {
            type: 'bar' as const,
            label: `${this.chosenYear}`,
            data: data,
            backgroundColor: charts.media_ordini.bkgColor,
            borderColor: charts.media_ordini.borderColor,
            borderWidth: charts.media_ordini.borderWidth,
            borderRadius: 6,
            order: 2,
          },
          ...this.yoyOverlayDataset(this.previousYearMonthlyMediaOrdini),
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
                callback: function (value: number | string) {
                  return typeof value === 'number' ? value.toFixed(2) : value;
                },
              },
          },
        },
        plugins: {
          title: {
            display: true,
            text: charts.media_ordini.title /*+ 
                    `${this.calculateTotalOrdersEvasi().toFixed(0)}`*/,
            font: {
              size: charts.font.sizeM,
              weight: +charts.font.weight,
              family: charts.font.family,
            },
            padding: {
              top: charts.font.top,
              bottom: charts.font.bottom,
            },
          },
          legend: {
            display: true,
            labels: {
              font: {
                size: charts.font.sizeS,
                family: charts.font.family,
              },
            },
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem) {
                return `${tooltipItem.label}: ${tooltipItem.raw}`;
              },
            },
          },
          // BUGFIX 2026-05-25 (Batch 7): datalabels removed — see the
          // matching note in ordiniEvasi above.
          datalabels: { display: false },
        },
      },
    });
    }, 0);
  }

  getOrders() {
    this.orderSrv.getClosedOrders().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((ordersData) => {
      this.ordersStock = ordersData;
      this.dates = [
        ...new Set(
          ordersData.map((date) => {
            let formattedDate = formatDate(
              date?.or_order_date,
              'dd/MM/yyyy',
              'it'
            );

            return formattedDate;
          })
        ),
      ];
      this.customers = [
        ...new Set(
          ordersData.map((client) => {
            return client.or_customer;
          })
        ),
      ];
      this.customers.unshift(this.showAll);
      this.dates.unshift(this.showAll2);
      console.debug('Orders are: ', this.ordersStock);
      console.debug('From server: ', ordersData);
      this.ordersStock = this.ordersStock.filter((order) => {
        const parsedClosedDate = parseISO(order.or_closed_date);
        const chosenYear = +this.chosenYear; 
        return parsedClosedDate.getFullYear() === chosenYear;
      });

      console.log('OrdersStock are', this.ordersStock);
      this.loading = false;
      this.cdr.detectChanges();
    });
  }

  calculatedTotale: number = 0;
  changeYear(e: string | number) {
    // BUGFIX 2026-05-25 (BUG A): the previous implementation called
    // `mediaOrdini(charts.media_ordini.labels, charts.media_ordini.data, ...)`
    // and `ordiniEvasi(charts.ordini_evasi.labels, charts.ordini_evasi.data, ...)`
    // here, passing HARDCODED data from stats.json instead of the data
    // about to be fetched. The chart rendered immediately with the
    // wrong (mock) values, then was supposed to be overridden by the
    // async API responses inside getStatisticOrdersClosed(). If those
    // responses were slow or errored, the chart stayed on the mock data
    // — root cause of "i grafici non si aggiornano quando filtro per
    // anno".
    //
    // Now `changeYear` just records the year and re-triggers the
    // canonical data fetch. The chart methods are called from inside
    // the fetch's subscribe handlers with the REAL data, exactly as
    // they should be.
    this.chosenYear = String(e);
    this.yearz = +this.chosenYear;
    // Re-engage the skeleton briefly while the new year's data is in
    // flight — feels much better than charts/values pretending they're
    // still current.
    this.isInitialLoading = true;
    // Wipe stale YoY overlays so the previous year's dashed line
    // doesn't briefly persist while the new fetches are in flight.
    this.previousYearMonthlyOrders = [];
    this.previousYearMonthlyMediaOrdini = [];
    this.previousYearMonthlyColli = [];
    this.previousYearMonthlyMediaSped = [];
    // Wipe stale lists feeding highlights / leaderboards so old-year
    // data doesn't flash before the new-year subscribes return.
    this.ordersByOperator = [];
    this.completedOrdersByCarrier = [];
    this.ordersCompletedByOperator = [];
    this.ordersDividedByCarrier = [];
    this.ordiniEvasioneMonthly = new ClosedOrdersStatistics(null);
    this.ordiniShipyMonthly = new ShippedOrdersClosed(null);
    this.ordiniShipsMonthly = new ShipmentsClosed(null);
    this.generalStatistics = new GeneralStatistics(null);
    this.destroyAllCharts();
    this.getStatisticOrdersClosed();
    this.getOrders();
  }

  selectedMonth: string = '';
  monthlyChange(e) {
    console.log('VEDEM EVENTIMENTUL', e);
    this.chosenYear = e;
  }

  downloadChart(canvasId: string, filename: string) {
    const canvas = this[canvasId].nativeElement;
    const width = canvas.width;
    const height = canvas.height;
    const tempCanvas = document.createElement('canvas');
    const tempContext = tempCanvas.getContext('2d');
    tempCanvas.width = width;
    tempCanvas.height = height;
    tempContext.fillStyle = '#ffffff';
    tempContext.fillRect(0, 0, width, height);
    tempContext.drawImage(canvas, 0, 0);
    const url = tempCanvas.toDataURL('image/jpeg', 1.0);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename + ' (' + this.chosenYear + ')' + '.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ordiniEvasioneMonthly: ClosedOrdersStatistics = new ClosedOrdersStatistics(
    null
  );
  totalClosedOrders: number = 0;
  currentMonth = new Date();
  currentMonthOrdersClosed: any;
  previousMonthOrdersClosed: any;
  percentageForPreviousMonth: number = 0;
  ordiniShipsMonthly: ShipmentsClosed = new ShipmentsClosed(null);
  ordiniShipyMonthly: ShippedOrdersClosed = new ShippedOrdersClosed(null);
  currentMonthSpediti: any;
  previousMonthShippingClosed: any;
  percentageShippingPreviousMonth: number = 0;
  ordersCompletedByOperator: OrdersCompletedByOperator[] = [];
  ordersByOperator: OrdersByOperator[] = [];
  ordersDividedByCarrier: OrdersDividedByCarrier[] = [];
  generalStatistics: GeneralStatistics = new GeneralStatistics(null);

  private readonly MONTH_NAMES: readonly string[] = [
    'Gennaio', 'Febbraio', 'Marzo', 'Aprile',
    'Maggio', 'Giugno', 'Luglio', 'Agosto',
    'Settembre', 'Ottobre', 'Novembre', 'Dicembre',
  ];

  getStatisticOrdersClosed() {
    // BUGFIX 2026-05-25 (BUG B / MAJOR robustness):
    //  - every subscribe now has an explicit `error` handler that logs
    //    via the level-aware Log facade and never silently fails;
    //  - the duplicated `cdr.detectChanges()` calls were removed from
    //    most subscribes (CD storm with 8 parallel observables). A
    //    single `markForCheck` per chart suffices because Angular's
    //    auto-CD already runs inside the HTTP zone.
    this.statistics.getStatAverageTime(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          // value not yet consumed by any chart; preserved for future use
        },
        error: (err) => Log.error('[Statistiche] getStatAverageTime failed', err),
      });

    this.statistics.getCompletedOrdersByCarrier(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.completedOrdersByCarrier = data?.data ?? [];
          const monthlyData = this.completedOrdersByCarrier.map(o => o.stat_nr_orders);
          const monthlyLabels = this.completedOrdersByCarrier.map(o => o.carrier_desc);
          const totalClosedOrders = monthlyData.reduce((acc, val) => acc + val, 0);
          this.totaleCorrieri(monthlyLabels, monthlyData, totalClosedOrders);
        },
        error: (err) => Log.error('[Statistiche] getCompletedOrdersByCarrier failed', err),
      });

    const previousYear = +this.chosenYear - 1;

    this.statistics.getAverageClosedOrdersStat(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.ordiniShipyMonthly = new ShippedOrdersClosed(data.data);
          const items = this.ordiniShipyMonthly.stat_average_monthly_closed_orders ?? [];
          const monthlyData = items.map(o => o.stat_total_monthly_average_closed_orders);
          const monthlyLabels = items.map(o => o.stat_month);
          const totalMediaOrdini = monthlyData.reduce((acc, val) => acc + val, 0);
          this.mediaOrdini(monthlyLabels, monthlyData, totalMediaOrdini);
        },
        error: (err) => Log.error('[Statistiche] getAverageClosedOrdersStat failed', err),
      });
    // YoY overlay for mediaOrdini.
    this.statistics.getAverageClosedOrdersStat(previousYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          const items = data?.data?.stat_average_monthly_closed_orders ?? [];
          this.previousYearMonthlyMediaOrdini = items.map((o: any) => o.stat_total_monthly_average_closed_orders ?? 0);
          // Re-render if the chart already exists with the current year.
          if (this.mediaOrdiniChart) {
            const labels = this.mediaOrdiniChart.data.labels as string[];
            const data = this.mediaOrdiniChart.data.datasets[0]?.data as number[];
            if (labels?.length && data?.length) this.mediaOrdini(labels, data);
          }
        },
        error: (err) => {
          Log.error('[Statistiche] getAverageClosedOrdersStat (YoY) failed', err);
          this.previousYearMonthlyMediaOrdini = [];
        },
      });

    this.statistics.getAverageShipmentsStat(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.ordiniShipsMonthly = new ShipmentsClosed(data.data);
          const items = this.ordiniShipsMonthly.stat_monthly_closed_orders ?? [];
          const monthlyData = items.map(o => o.stat_total_monthly_media_boxes);
          const monthlyLabels = items.map(o => o.stat_month);
          const totalMediaSpedizioni = monthlyData.reduce((acc, val) => acc + val, 0);
          this.mediaSpedizioni(monthlyLabels, monthlyData, totalMediaSpedizioni);
        },
        error: (err) => Log.error('[Statistiche] getAverageShipmentsStat failed', err),
      });
    // YoY overlay for mediaSpedizioni.
    //
    // BUGFIX 2026-05-25 (Batch 7): the raw API payload uses
    // `stat_monthly_shipped_orders` with `stat_total_monthly_media_orders`,
    // but the `ShipmentsClosed` model RENAMES those fields to
    // `stat_monthly_closed_orders` / `stat_total_monthly_media_boxes`.
    // The previous version read the raw payload using the renamed
    // names → got `undefined` → empty array → no overlay. Fixed by
    // routing through the model constructor (same as the current-year
    // subscribe above).
    this.statistics.getAverageShipmentsStat(previousYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) {
            this.previousYearMonthlyMediaSped = [];
            return;
          }
          const prev = new ShipmentsClosed(data.data);
          this.previousYearMonthlyMediaSped =
            (prev.stat_monthly_closed_orders ?? []).map(o => o.stat_total_monthly_media_boxes ?? 0);
          if (this.mediaSpedizioniChart) {
            const labels = this.mediaSpedizioniChart.data.labels as string[];
            const cy = this.mediaSpedizioniChart.data.datasets[0]?.data as number[];
            if (labels?.length && cy?.length) this.mediaSpedizioni(labels, cy);
          }
        },
        error: (err) => {
          Log.error('[Statistiche] getAverageShipmentsStat (YoY) failed', err);
          this.previousYearMonthlyMediaSped = [];
        },
      });

    this.statistics.getBoxesStatistic(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          const boxes = data?.data?.stat_monthly_boxes_delivered;
          if (!boxes) return;
          const monthlyData = boxes.map(o => o.stat_total_monthly_boxes);
          const monthlyLabels = boxes.map(o => o.stat_month);
          const totaleBoxes = monthlyData.reduce((acc, val) => acc + val, 0);
          this.colliSpediti(monthlyLabels, monthlyData, totaleBoxes);
        },
        error: (err) => Log.error('[Statistiche] getBoxesStatistic failed', err),
      });
    // YoY overlay for colliSpediti.
    this.statistics.getBoxesStatistic(previousYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          const boxes = data?.data?.stat_monthly_boxes_delivered ?? [];
          this.previousYearMonthlyColli = boxes.map((o: any) => o.stat_total_monthly_boxes ?? 0);
          if (this.colliSpeditiChart) {
            const labels = this.colliSpeditiChart.data.labels as string[];
            const data = this.colliSpeditiChart.data.datasets[0]?.data as number[];
            if (labels?.length && data?.length) this.colliSpediti(labels, data);
          }
        },
        error: (err) => {
          Log.error('[Statistiche] getBoxesStatistic (YoY) failed', err);
          this.previousYearMonthlyColli = [];
        },
      });

    this.statistics.getStatisticOrderClosed(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.ordiniEvasioneMonthly = data.data;

          const currentMonthIndex = new Date().getMonth();
          const previousMonthIndex = (currentMonthIndex - 1 + 12) % 12;
          const currentMonthName = this.MONTH_NAMES[currentMonthIndex];
          const previousMonthName = this.MONTH_NAMES[previousMonthIndex];

          const items = this.ordiniEvasioneMonthly.stat_monthly_closed_orders ?? [];

          this.currentMonthOrdersClosed =
            items.filter(o => o.stat_month === currentMonthName) || [];
          this.previousMonthOrdersClosed =
            items.filter(o => o.stat_month === previousMonthName) || [];

          const currentMonthTotalOrders = this.currentMonthOrdersClosed[0]?.stat_total_monthly_orders ?? 0;
          const previousMonthTotalOrders = this.previousMonthOrdersClosed[0]?.stat_total_monthly_orders ?? 0;

          this.percentageForPreviousMonth = previousMonthTotalOrders > 0
            ? (currentMonthTotalOrders / previousMonthTotalOrders) * 100
            : 0;

          const monthlyData = items.map(o => o.stat_total_monthly_orders);
          const monthlyLabels = items.map(o => o.stat_month);
          this.totalClosedOrders = monthlyData.reduce((acc, val) => acc + val, 0);

          // Year-over-year comparison (current year vs previous year totals).
          const previousYear = +this.chosenYear - 1;
          const ordiniCorrenti = this.totalClosedOrders;
          this.statistics.getStatisticOrderClosed(previousYear)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (prevData) => {
                const prev = prevData?.data?.stat_monthly_closed_orders;
                if (!prev) {
                  this.previousYearMonthlyOrders = [];
                  return;
                }
                const prevValues = prev.map(o => o.stat_total_monthly_orders ?? 0);
                const totalPrevOrders = prevValues.reduce((acc, val) => acc + val, 0);
                this.totalLocalOrders = ordiniCorrenti;
                this.percentageLocalOrders = totalPrevOrders > 0
                  ? ((ordiniCorrenti - totalPrevOrders) / totalPrevOrders) * 100
                  : 0;

                // Feed the YoY overlay (dashed line) on the ordiniEvasi chart.
                this.previousYearMonthlyOrders = prevValues;
                this.ordiniEvasi(monthlyLabels, monthlyData, this.totalClosedOrders);
              },
              error: (err) => {
                Log.error('[Statistiche] getStatisticOrderClosed (previous year) failed', err);
                this.previousYearMonthlyOrders = [];
              },
            });

          // Initial draw without YoY overlay; the subscribe above will
          // re-draw with the overlay once previous-year data lands.
          this.ordiniEvasi(monthlyLabels, monthlyData, this.totalClosedOrders);
          // Refresh KPI sparklines now that we have the current year's
          // monthly orders series.
          this.refreshSparklines();
        },
        error: (err) => Log.error('[Statistiche] getStatisticOrderClosed failed', err),
      });

    this.statistics.getCompletedOrdersByOperator(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.ordersCompletedByOperator = data?.data ?? [];
          this.operatoreMethod(this.ordersCompletedByOperator);
        },
        error: (err) =>
          Log.error('[Statistiche] getCompletedOrdersByOperator failed', err),
      });

    this.statistics.getCompletedOrdersByOperatorNoMonth(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.ordersByOperator = data.data;
          const dataForChart = this.ordersByOperator.map(o => o.stat_nr_orders);
          const operators = this.ordersByOperator.map(
            o => `${o.ac_first_name} ${o.ac_last_name}`
          );
          this.totaleOperatori(operators, dataForChart);
        },
        error: (err) =>
          Log.error('[Statistiche] getCompletedOrdersByOperatorNoMonth failed', err),
      });

    this.statistics.getOrdersDividedByCarrier(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.ordersDividedByCarrier = data.data;

          const dataForCarriers = this.ordersDividedByCarrier.map(carrier =>
            this.MONTH_NAMES.map(month => {
              const found = carrier.stat_completed_orders_by_carriers
                .find(entry => entry.stat_month === month);
              return found ? found.stat_t_orders : 0;
            })
          );
          const carrierDesc = this.ordersDividedByCarrier.map(c => c.stat_carrier_desc);
          this.corriereMethod(carrierDesc, dataForCarriers);
        },
        error: (err) =>
          Log.error('[Statistiche] getOrdersDividedByCarrier failed', err),
      });

    this.statistics.getGeneralStatistics(this.chosenYear)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (!data?.data) return;
          this.generalStatistics = data.data;
          // First "real" data has landed → hide skeleton.
          this.isInitialLoading = false;
          this.cdr.detectChanges();
          this.refreshSparklines();
        },
        error: (err) => {
          Log.error('[Statistiche] getGeneralStatistics failed', err);
          this.isInitialLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  // BUGFIX 2026-05-25 (BUG B.2): these were originally field-init
  // computations evaluated ONCE at construction time on the mock
  // `mediaMediaOrdini` (which is itself derived from stats.json mock
  // data). They were never recomputed after the real API responses
  // landed, so the UI permanently displayed a mock-based estimate.
  // Converted to getters so the value tracks the current real data.
  get tempo_prep(): number {
    const media = this.calculateTotalMediaEvasi();
    return media > 0 ? 8 / media : 0;
  }

  get tempoPrepInMinuti(): string {
    return (this.tempo_prep * 60).toFixed(2);
  }

  calculateTotalOrdersEvasi(): number {
    if (
      this.generalStatistics &&
      this.generalStatistics.s_t_orders_perc != null
    ) {
      const baseTotale = this.totaleOrdiniEvasi || 0;
      const percentuale = this.generalStatistics.s_t_orders_perc;
      return baseTotale * (1 + percentuale / 100);
    }
    return this.totaleOrdiniEvasi || 0;
  }

  changeStatAverageTime(id: number) {
    this.statistics.getStatAverageTime(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // value not yet consumed by any chart; preserved for future
          // wiring (same as the seed call in ngOnInit)
        },
        error: (err) => Log.error('[Statistiche] getStatAverageTime failed', err),
      });
  }

  calculateTotalColliSpediti(): number {
    if (
      this.generalStatistics &&
      this.generalStatistics.stat_total_boxes_delivered != null
    ) {
      const baseTotale = this.totaleColliSpediti || 0;
      const percentuale = this.generalStatistics.stat_total_boxes_delivered;
      return baseTotale * (1 + percentuale / 100);
    }
    console.log(
      'TotalColliSpediti (total shipped boxes): ',
      this.totaleColliSpediti
    );
    return this.totaleColliSpediti || 0;
  }

  calculateTotalMediaSpedizioni(): number {
    if (
      this.generalStatistics &&
      this.generalStatistics.stat_daily_avg_boxes_delivered != null
    ) {
      const baseTotale = this.mediaMediaSpedizioni || 0;
      const percentuale = this.generalStatistics.stat_daily_avg_boxes_delivered;
      console.log(
        'Media spedizioni (average shipments): ',
        baseTotale,
        'Percentuale spedizioni (% shipments): ',
        percentuale
      );
      const result = baseTotale * (1 + percentuale / 100);
      console.log('Media colli spediti (average shipped boxes): ', result);
      return result;
    }
    return this.mediaMediaSpedizioni || 0;
  }

  calculateTotalMediaEvasi(): number {
    if (
      this.generalStatistics &&
      this.generalStatistics.stat_daily_avg_orders_completed != null
    ) {
      const baseTotale = this.mediaMediaOrdini || 0;
      const percentuale =
        this.generalStatistics.stat_daily_avg_orders_completed;
      console.log(
        'Media evasioni (Average orders): ',
        baseTotale,
        'Percentuale ordini (% orders): ',
        percentuale
      );
      const result = baseTotale * (1 + percentuale / 100);
      console.log('Media ordini evasi (Average completed orders): ', result);
      return result;
    }
    return this.mediaMediaOrdini || 0;
  }

  getPreparationTimeInHours(endDate: Date, startDate: Date): number {
    if (!endDate || !startDate) {
      console.log('Invalid dates: ', { endDate, startDate });
      return 0;
    }
    const diffInMilliseconds = endDate.getTime() - startDate.getTime();
    /*console.log('Preparation time in ms:', diffInMilliseconds);*/
    const preparationTimeInHours = diffInMilliseconds / (1000 * 60 * 60);
    /*console.log('Preparation time in hours:', preparationTimeInHours);*/
    return preparationTimeInHours;
  }

  calculateAveragePreparationTimeForYear(year: string): string {
    const parsedYear = parseInt(year, 10);
    if (isNaN(parsedYear)) {
      return 'Anno non valido';
    }
    const filteredOrders = this.ordersStock.filter((order) => {
      const orderYear = new Date(order.or_assigned_date).getFullYear();
      return orderYear === parsedYear;
    });
    if (filteredOrders.length === 0) {
      return "Nessun dato per l'anno specificato";
    }
    const totalPreparationTimeInHours = filteredOrders.reduce(
      (total, order) => {
        const preparationTime = this.getPreparationTimeInHours(
          new Date(order.or_closed_date),
          new Date(order.or_assigned_date)
        );
        return total + preparationTime;
      },
      0
    );
    const averagePreparationTimeInHours =
      totalPreparationTimeInHours / filteredOrders.length;
    const days = Math.floor(averagePreparationTimeInHours / 24);
    const hours = Math.floor(averagePreparationTimeInHours % 24);
    const minutes = Math.floor((averagePreparationTimeInHours * 60) % 60);
    return `${days} giorni, ${hours} ore, ${minutes} minuti`;
  }

  scrollToElement(id: string, highlightClass: 'highlight1' | 'highlight2' | 'highlight3' | 'highlight4'): void {
    const element = document.getElementById(id);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    element.classList.add(highlightClass);
    setTimeout(() => element.classList.remove(highlightClass), 1500);
  }

  scroll1(id: string): void { this.scrollToElement(id, 'highlight1'); }
  scroll2(id: string): void { this.scrollToElement(id, 'highlight2'); }
  scroll3(id: string): void { this.scrollToElement(id, 'highlight3'); }
  scroll4(id: string): void { this.scrollToElement(id, 'highlight4'); }

  isGeneratingPDF = false;

  generatePDF() {
    this.isGeneratingPDF = true;

    setTimeout(() => {
      const data = document.getElementById('report-content');
      if (data) {
        html2canvas(data).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

          const filename = `report-statistiche-${this.chosenYear}.pdf`;
          pdf.save(filename);
          this.isGeneratingPDF = false;
        });
      }
    }, 100);
  }

  totalLocalOrders: number = 0;
  percentageLocalOrders: number = 0;

  // ─── Dashboard-derived insights (Chunk F + Batch 6) ────────────────
  // All getters below compute values from data already in component
  // state — NO new API calls. In year mode (chosenMonthName='') the
  // values reflect the whole selected year; in month mode they zoom
  // in on the chosen month.

  /** KPI: total orders for the year, OR for the selected month. */
  get kpiTotalOrders(): number | null {
    if (!this.isMonthMode) {
      return this.generalStatistics?.stat_total_orders ?? null;
    }
    const item = this.ordiniEvasioneMonthly?.stat_monthly_closed_orders
      ?.find((o) => o.stat_month === this.chosenMonthName);
    return item?.stat_total_monthly_orders ?? null;
  }

  /** KPI: total boxes (year OR month). Boxes monthly via boxes endpoint. */
  get kpiTotalBoxes(): number | null {
    if (!this.isMonthMode) {
      return this.generalStatistics?.stat_total_boxes_delivered ?? null;
    }
    const data = this.colliSpeditiChart?.data?.datasets?.[0]?.data as number[] | undefined;
    const idx = this.selectedMonthIndex;
    return idx >= 0 && data ? (data[idx] ?? null) : null;
  }

  /** KPI: average orders per day (year) OR month total ÷ ~22 wk-days. */
  get kpiAvgOrdersPerDay(): number | null {
    if (!this.isMonthMode) {
      return this.generalStatistics?.stat_daily_avg_orders_completed ?? null;
    }
    const monthly = this.ordiniShipyMonthly?.stat_average_monthly_closed_orders
      ?.find((o) => o.stat_month === this.chosenMonthName);
    return monthly?.stat_total_monthly_average_closed_orders ?? null;
  }

  /** KPI: average shipments per day (year) OR monthly value. */
  get kpiAvgShipmentsPerDay(): number | null {
    if (!this.isMonthMode) {
      return this.generalStatistics?.stat_daily_avg_boxes_delivered ?? null;
    }
    const monthly = this.ordiniShipsMonthly?.stat_monthly_closed_orders
      ?.find((o) => o.stat_month === this.chosenMonthName);
    return monthly?.stat_total_monthly_media_boxes ?? null;
  }

  /** Month with the highest closed-orders count (year mode only). */
  get bestMonth(): { name: string; count: number } | null {
    const items = this.ordiniEvasioneMonthly?.stat_monthly_closed_orders;
    if (!items?.length) return null;
    const top = items.reduce(
      (best, current) =>
        (current.stat_total_monthly_orders ?? 0) > (best?.stat_total_monthly_orders ?? -Infinity)
          ? current
          : best,
      items[0]
    );
    return { name: top.stat_month, count: top.stat_total_monthly_orders ?? 0 };
  }

  /**
   * Top operator — year mode uses the annual `ordersByOperator`; month
   * mode aggregates `ordersCompletedByOperator` filtered to the chosen
   * month.
   */
  get topOperator(): { name: string; count: number } | null {
    if (this.isMonthMode) {
      const rows = this.ordersCompletedByOperator
        ?.filter((o) => o.stat_month === this.chosenMonthName) ?? [];
      if (!rows.length) return null;
      const top = rows.reduce(
        (best, current) =>
          (current.nr_orders ?? 0) > (best?.nr_orders ?? -Infinity) ? current : best,
        rows[0]
      );
      return {
        name: `${top.ac_first_name ?? ''} ${top.ac_last_name ?? ''}`.trim() || '—',
        count: top.nr_orders ?? 0,
      };
    }
    if (!this.ordersByOperator?.length) return null;
    const top = this.ordersByOperator.reduce(
      (best, current) =>
        (current.stat_nr_orders ?? 0) > (best?.stat_nr_orders ?? -Infinity) ? current : best,
      this.ordersByOperator[0]
    );
    return {
      name: `${top.ac_first_name ?? ''} ${top.ac_last_name ?? ''}`.trim() || '—',
      count: top.stat_nr_orders ?? 0,
    };
  }

  /**
   * Top carrier — year mode: `completedOrdersByCarrier`; month mode:
   * sum each carrier's monthly value from `ordersDividedByCarrier`
   * filtered to the chosen month.
   */
  get topCarrier(): { name: string; count: number } | null {
    if (this.isMonthMode) {
      const rows = (this.ordersDividedByCarrier ?? [])
        .map((c) => {
          const monthEntry = c.stat_completed_orders_by_carriers
            ?.find((e) => e.stat_month === this.chosenMonthName);
          return { name: c.stat_carrier_desc || '—', count: monthEntry?.stat_t_orders ?? 0 };
        })
        .filter((r) => r.count > 0);
      if (!rows.length) return null;
      return rows.reduce((best, cur) => (cur.count > best.count ? cur : best), rows[0]);
    }
    if (!this.completedOrdersByCarrier?.length) return null;
    const top = this.completedOrdersByCarrier.reduce(
      (best, current) =>
        (current.stat_nr_orders ?? 0) > (best?.stat_nr_orders ?? -Infinity) ? current : best,
      this.completedOrdersByCarrier[0]
    );
    return { name: top.carrier_desc || '—', count: top.stat_nr_orders ?? 0 };
  }

  /** Avg boxes per order — year-level only (no per-month breakdown available). */
  get avgBoxesPerOrder(): number {
    const total = this.generalStatistics?.stat_total_orders ?? 0;
    const boxes = this.generalStatistics?.stat_total_boxes_delivered ?? 0;
    return total > 0 ? boxes / total : 0;
  }

  /** Top 5 operators leaderboard (year mode OR month-aggregated). */
  get topOperatorsLeaderboard(): { name: string; count: number; percent: number }[] {
    if (this.isMonthMode) {
      const rows = (this.ordersCompletedByOperator ?? [])
        .filter((o) => o.stat_month === this.chosenMonthName)
        .map((o) => ({
          name: `${o.ac_first_name ?? ''} ${o.ac_last_name ?? ''}`.trim() || '—',
          count: o.nr_orders ?? 0,
        }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);
      const max = rows[0]?.count ?? 0;
      return rows.map((r) => ({ ...r, percent: max > 0 ? (r.count / max) * 100 : 0 }));
    }
    if (!this.ordersByOperator?.length) return [];
    const sorted = [...this.ordersByOperator]
      .sort((a, b) => (b.stat_nr_orders ?? 0) - (a.stat_nr_orders ?? 0))
      .slice(0, 5);
    const max = sorted[0]?.stat_nr_orders ?? 0;
    return sorted.map((o) => ({
      name: `${o.ac_first_name ?? ''} ${o.ac_last_name ?? ''}`.trim() || '—',
      count: o.stat_nr_orders ?? 0,
      percent: max > 0 ? ((o.stat_nr_orders ?? 0) / max) * 100 : 0,
    }));
  }

  /** Top 5 carriers leaderboard (year OR month-aggregated). */
  get topCarriersLeaderboard(): { name: string; count: number; percent: number }[] {
    if (this.isMonthMode) {
      const rows = (this.ordersDividedByCarrier ?? [])
        .map((c) => {
          const monthEntry = c.stat_completed_orders_by_carriers
            ?.find((e) => e.stat_month === this.chosenMonthName);
          return { name: c.stat_carrier_desc || '—', count: monthEntry?.stat_t_orders ?? 0 };
        })
        .filter((r) => r.count > 0)
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);
      const max = rows[0]?.count ?? 0;
      return rows.map((r) => ({ ...r, percent: max > 0 ? (r.count / max) * 100 : 0 }));
    }
    if (!this.completedOrdersByCarrier?.length) return [];
    const sorted = [...this.completedOrdersByCarrier]
      .sort((a, b) => (b.stat_nr_orders ?? 0) - (a.stat_nr_orders ?? 0))
      .slice(0, 5);
    const max = sorted[0]?.stat_nr_orders ?? 0;
    return sorted.map((c) => ({
      name: c.carrier_desc || '—',
      count: c.stat_nr_orders ?? 0,
      percent: max > 0 ? ((c.stat_nr_orders ?? 0) / max) * 100 : 0,
    }));
  }

  // ─── Empty-state flags (Batch 2) ───────────────────────────────────
  // Each getter returns true when its underlying dataset has at least
  // one row to display. The template uses these to render a fallback
  // "Nessun dato per l'anno X" overlay on top of the empty canvas.

  get hasOrdiniEvasiData(): boolean {
    const items = this.ordiniEvasioneMonthly?.stat_monthly_closed_orders;
    return !!items?.some((o) => (o.stat_total_monthly_orders ?? 0) > 0);
  }

  get hasMediaOrdiniData(): boolean {
    const items = this.ordiniShipyMonthly?.stat_average_monthly_closed_orders;
    return !!items?.some((o) => (o.stat_total_monthly_average_closed_orders ?? 0) > 0);
  }

  get hasColliSpeditiData(): boolean {
    // The colliSpediti subscribe doesn't store its data on a typed
    // field; we rely on Chart.js itself having data points.
    return !!this.colliSpeditiChart?.data?.datasets?.[0]?.data?.length;
  }

  get hasMediaSpedizioniData(): boolean {
    const items = this.ordiniShipsMonthly?.stat_monthly_closed_orders;
    return !!items?.some((o) => (o.stat_total_monthly_media_boxes ?? 0) > 0);
  }

  get hasOperatoriData(): boolean {
    return !!this.ordersByOperator?.some((o) => (o.stat_nr_orders ?? 0) > 0);
  }

  get hasOperatoreMensileData(): boolean {
    return !!this.ordersCompletedByOperator?.length;
  }

  get hasCorrieriData(): boolean {
    return !!this.completedOrdersByCarrier?.some((c) => (c.stat_nr_orders ?? 0) > 0);
  }

  get hasCorriereMensileData(): boolean {
    return !!this.ordersDividedByCarrier?.length;
  }

  /**
   * One-sentence summary used under the title. In year mode it reads
   * "Quest'anno hai evaso N ordini…", in month mode "A <Mese> hai
   * evaso N ordini…" — with the boxes figure pulled from the colli
   * monthly dataset when available.
   */
  get yearSummaryLine(): string {
    if (this.isMonthMode) {
      const monthOrders = this.kpiTotalOrders;
      if (monthOrders === null || monthOrders === undefined) {
        return `Caricamento dati per ${this.chosenMonthName} ${this.chosenYear}…`;
      }
      const monthBoxes = this.kpiTotalBoxes ?? 0;
      return `A ${this.chosenMonthName} ${this.chosenYear} hai evaso ${monthOrders} ordini e spedito ${monthBoxes} colli.`;
    }

    const totalOrders = this.generalStatistics?.stat_total_orders;
    const yoy = this.percentageLocalOrders;
    if (totalOrders === undefined || totalOrders === null) {
      return `Caricamento dati per l'anno ${this.chosenYear}…`;
    }
    const totalBoxes = this.generalStatistics?.stat_total_boxes_delivered ?? 0;
    const yoyText = yoy === 0
      ? ''
      : yoy > 0
        ? ` (+${yoy.toFixed(1)}% vs ${+this.chosenYear - 1})`
        : ` (${yoy.toFixed(1)}% vs ${+this.chosenYear - 1})`;
    return `Quest'anno hai evaso ${totalOrders} ordini${yoyText} e spedito ${totalBoxes} colli.`;
  }

  getClosedOrdersByYear(year: number): Orders.IOrderClosed[] {
    return this.ordersStock.filter((order) => {
      const date = new Date(order.or_closed_date);
      return date.getFullYear() === year;
    });
  }

  getClosedOrdersCount(year: number): number {
    return this.getClosedOrdersByYear(year).length;
  }

  getClosedOrdersPercentageDiff(currentYear: number): number {
    const current = this.getClosedOrdersCount(currentYear);
    const previous = this.getClosedOrdersCount(currentYear - 1);
    if (previous === 0) return 100;
    return ((current - previous) / previous) * 100;
  }

  exportChartDataToExcel(
    chart: Chart,
    labels: string[],
    baseFileName: string,
    year: string,
    firstColumnHeader: string = 'Mese'
  ) {
    if (!chart) return;

    const datasets = chart.data.datasets.map((d: any) => ({
      label: d.label,
      data: d.data,
    }));

    const titleText = `${baseFileName}_${year}`;
    const fileName = `${baseFileName}_${year}`;

    this.excelServ.exportAsExcelFileFromChart(
      labels,
      datasets,
      fileName,
      titleText,
      firstColumnHeader
    );
  }
  
}
